module.exports = __webpack_public_path__ + "media/images/logos/youtube-light-38148023a987e37f08049aaf81863f66.svg";